const pageHierarchyActionTypes =  {
    SET_SEARCH_KEYWORD: "SET_SEARCH_KEYWORD",    
    SET_ITEM_TEMPLATE: "SET_ITEM_TEMPLATE",
    SET_DRAG_ITEM_TEMPLATE: "SET_DRAG_ITEM_TEMPLATE",
    SELECT_PAGE: "SELECT_PAGE",
    CHANGE_SELECTED_PAGE_PATH: "CHANGE_SELECTED_PAGE_PATH"
};

export default pageHierarchyActionTypes;